/**Input types */
const INPUTPOINTS = 'InputPoints';
const INPUTCHECKBOX = 'InputCheckbox';
const INPUTNUMBER = 'InputNumber';
const INPUTTEXT = 'InputText';
const INPUTRADIO = 'InputRadio';
const INPUTTABLE = 'InputTable';
const INPUTVISIONTABLEA = 'InputVisionTableA';
const INPUTVISIONTABLEB = 'InputVisionTableB';
const INPUTDATE = 'InputDate';
const INPUTTIME = 'InputTime';
const INPUTFILE = 'InputFile';
const TEXTFIELD = 'TextField';
const DIVIDERFIELD = 'DividerField';




/**Survey status */
const UNSIGNED = 'unsigned';
const SIGNED = 'signed';


/**Survey types */
const MEDICALRECORDS = 'tickets_medical_records';
const REFERRALS = 'tickets_referrals';
const QUESTIONNAIRES = 'tickets_surveys';
const MESSAGES = 'messages';



export default {
  TYPES: {
		MEDICALRECORDS,
		REFERRALS,
    QUESTIONNAIRES,
    MESSAGES,
	},
	QUESTION: {
		TYPES: {
			INPUTPOINTS,
			INPUTCHECKBOX,
			INPUTNUMBER,
			INPUTTEXT,
			INPUTRADIO,
      INPUTTABLE,
      INPUTVISIONTABLEA,
      INPUTVISIONTABLEB,
      INPUTDATE,
      INPUTFILE,
      TEXTFIELD,
      DIVIDERFIELD,
      INPUTTIME,
		},
	},
	STATUS: {
		UNSIGNED,
		SIGNED,
	},
};
